import {setDragInfoPos} from "../app/utils";

export function isDragging(boolean) {
	return function(dispatch){

        let sharingUI = document.querySelector('.sharing');

        const displayDragInfo = (e) =>{
            setDragInfoPos(e.pageX, e.pageY)
        };

        dispatch({
            type: "IS_DRAGGING",
            payload: boolean
        });

		if(boolean){
            sharingUI.addEventListener('mousemove', displayDragInfo);
            sharingUI.style.cursor = "grabbing";
		} else {
            sharingUI.removeEventListener('mousemove', displayDragInfo);
            sharingUI.style.cursor = "default";
		}

	}
}